import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

/**
 * Login page
 */
function LoginPage() {
  const { login } = useAuth();

  const [username, setUsername]         = useState('');
  const [password, setPassword]         = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]               = useState('');
  const [loading, setLoading]           = useState(false);
  const [inactiveMsg, setInactiveMsg]   = useState(false);

  // Show message when logout was triggered by inactivity
  useEffect(() => {
    const handler = () => setInactiveMsg(true);
    window.addEventListener('auth:inactivity-logout', handler);
    return () => window.removeEventListener('auth:inactivity-logout', handler);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInactiveMsg(false);
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.message ||
        'Anmeldung fehlgeschlagen';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-wrapper"
      style={{ backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.6) 0 100%), url(${process.env.PUBLIC_URL}/images/drop-red-water.jpg)` }}
    >
      <div className="login-card">
        <h2 className="login-title">EUG Foods Admin</h2>
        <p className="login-subtitle">Please sign in</p>

        {inactiveMsg && (
          <p className="login-message login-message--info">
            You were signed out due to inactivity.
          </p>
        )}
        {error && (
          <p className="login-message login-message--error">{error}</p>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">
            Username
            <input
              className="login-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </label>

          <label className="login-label">
            Password
            <div className="login-password-wrapper">
              <input
                className="login-input"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </label>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
